import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getDocument } from "@faire/web--source/common/globals/getDocument";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
export var loadScript = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(src, globalIdentifier) {
        var existing;
        return _ts_generator(this, function(_state) {
            existing = getGlobalProperty(globalIdentifier);
            if (existing) {
                return [
                    2,
                    existing
                ];
            }
            return [
                2,
                new Promise(function(resolve, reject) {
                    var document = getDocument();
                    if (!document) {
                        return reject("Document not found");
                    }
                    var script = document.createElement("script");
                    script.id = globalIdentifier;
                    script.onerror = reject;
                    script.onload = function() {
                        resolve(getGlobalProperty(globalIdentifier));
                    };
                    script.src = src;
                    document.body.appendChild(script);
                })
            ];
        });
    });
    return function loadScript(src, globalIdentifier) {
        return _ref.apply(this, arguments);
    };
}();
